import Vue from 'vue'
import Vuex from 'vuex'
import { ObjectsWithId, Lead, Payout } from 'src/classes/datamodel.js'
import api from './apiServices.js'
import router from '../router/router.js'
import NProgress from 'nprogress'
// import Notify from '../components/NotificationPlugin/index.js'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
      userSession: '',
      periodSelected: {}, // {value: 'this month', label: 'This Month' previous: 'Last Month', evo: 'Last 12 Months'}
      companySelected: 0,
      modal: { mode: '', current: '', object: {} },
      selectedObjects: { objectsJson: null, filter: null }, // Select mode is initiated in tables when objectsJson != null
      classes: {
        Payout: {
          _status: Payout._status,
          _type: Payout._type
        },
        Lead: {
          _status: Lead._status
        }
      },
      data: {
        invoices: [],
        payouts: [],
        leads: []
      },
      dataPrevious: {
        invoices: [],
        payouts: [],
        leads: []
      },
      baseData: {
        affiliateAccounts: [],
        incentifyerAccounts: [],
        users: [],
        affiliateCompanies: [],
        paymentCards: [],
        paymentCardProviders: [],
        periods: []
      }
    },





    /////////////////////////////////////////////////////
    ///////////////////// GETTERS ///////////////////////
    /////////////////////////////////////////////////////
    getters: {
      currency                () { return '$' }, 
      periodSelected     (state) { return state.periodSelected },
      companySelected    (state) { return state.companySelected },
      periods            (state) { return state.baseData.periods || [] },
      modal              (state) { return state.modal },

      Payout             (state) { return state.classes.Payout },
      Lead               (state) { return state.classes.Lead },

      affiliateAccounts  (state) { return state.baseData.affiliateAccounts || [] },
      incentifyerAccounts (state) { return state.baseData.incentifyerAccounts || [] },
      users              (state) { return state.baseData.users || [] },
      affiliateCompanies (state) { return state.baseData.affiliateCompanies || [] },
      paymentCards       (state) { return state.baseData.paymentCards || [] },
      paymentCardProviders (state) { return state.baseData.paymentCardProviders || [] },


      invoices           (state) { return state.data.invoices || [] },
      leads              (state) { return state.data.leads || [] },
      payouts            (state) { return state.data.payouts || [] },

      session            (state) { return state.userSession || JSON.parse(localStorage.getItem('userSession')) },
      user               (state, getters) { return getters.session.user },
      


      // TMP
      affiliates         (state) { return [] },
      companies          (state) { return [] },
      spiffsLeadsSetup   (state) { return {} },
      totalPayouts:      (state, getters) => obj => { return 0 },
      totalPayoutsPrevious: (state, getters) => obj => { return 0 },
      totalLeads         (state) { return 0 },
      totalLeadsPrevious (state) { return 0 },
      totalLeadsClosed   (state) { return 0 },
      totalLeadsClosedPrevious (state) { return 0 },


      selectedObjectsJson (state) {
        return state.selectedObjects.objectsJson
      },

      selectedObjects (state, getters) {
        return getters.selectedObjectsJson ? getters.selectedObjectsJson.values : []
      },
      
      selectedObjectsFilter (state) {
        return state.selectedObjects.filter
      },
      


      
    /////////////////////////////////////////////////////
    //////////////////// FUNCTIONS //////////////////////
    /////////////////////////////////////////////////////



      
    /////////////////////////////////////////////////////
    /////////// FUNCTIONS WITH ARGUMENTS ////////////////
    /////////////////////////////////////////////////////

    getCardsForAffiliateId: (state, getters) => id => {
      return getters.paymentCards
    },
    
    getAffiliateName: (state, getters) => id => {
      const affiliate = getters.getAffiliate(id)
      if (!affiliate) return ''
      return `${affiliate.firstName} ${affiliate.lastName}`
    },
    
    getAffiliate: (state, getters) => id => {
      if (!id) return undefined
      return getters.users.find(u => u.type == 'affiliate' && u.id == id)
    },


  },
    /////////////////////////////////////////////////////
    ///////////////////// MUTATIONS /////////////////////
    /////////////////////////////////////////////////////
    mutations: {


      UPDATE_BASE_DATA (state, payload) {
        console.log('UPDATE_BASE_DATA, payload = ', payload)
        state.baseData = payload
      },
      UPDATE_DATASET (state, payload) {
        console.log('UPDATE_DATASET, payload = ', payload)
        state.data = payload.data
        state.dataPrevious = payload.dataPrevious
      },
      STORE_SESSION (state, userSession) {
        localStorage.setItem('userSession', JSON.stringify(userSession))
        state.userSession = userSession
      },
      /** This methods removes the token and user from local storage and removes the session in the state */
      CLEAR_SESSION (state) {
        let userSession = state.userSession
        console.log('CLEAR_SESSION, userSession = ', userSession)
        if (userSession && userSession.token) {
          userSession.token = ''
          userSession.user = ''
          localStorage.setItem('userSession', JSON.stringify(userSession))
          state.userSession = ''
        }
      },

      // UPDATE_LEADS (state, leads) {
      //   state.data.leads = leads
      // },

      // UPDATE_PAYOUTS (state, payouts) {
      //   state.data.payouts = payouts
      // },



      //////////////////////////// Other: ////////////////////////////
      SET_PERIOD_SELECTED (state, period) {
        if (typeof period == 'string') {
          state.periodSelected = state.baseData.periods.find(p => p.value == period)
        }
        else {
          state.periodSelected = period
        }
      },
      SET_COMPANY_SELECTED (state, company) { // can take either AffiliateCompany or companyId as parameter
        if (!company && company != 0) {
          const affiliateCompanies = state.baseData.affiliateCompaniesJson.values
          if (affiliateCompanies && affiliateCompanies.length > 0) {
            company = affiliateCompanies.length > 1 ? 0 : affiliateCompanies[0].id
          }
          else company = 0
        }
        state.companySelected = Number(company) || company == 0 ? company : company.id
      },
      OPEN_MODAL (state, arg) {
        console.log('OPEN_MODAL: ', arg)
        // Lead modal:
        if (arg.name == 'Lead') {
          switch (arg.mode) {
            case 'Create':
              state.modal.object = arg.object || new Lead({status: Lead._status.RECEIVED.value})
              break;
            case 'Close':
              state.modal.object = arg.object || new Lead({status: Lead._status.CLOSED.value})
              console.log('close')
              break;
            case 'Lost':
              console.log('lost')
              state.modal.object = arg.object || new Lead({status: Lead._status.LOST.value})
              break;  
            case 'Edit':
              console.log('Edit')
            default:
              state.modal.object = arg.object || new Lead()
              break;
          }
          if (arg.mode == 'Close' || arg.mode == 'Lost') {
            // we activate the table row select mode (checkboxes)
            state.selectedObjects.objectsJson = new ObjectsWithId()
          }
        } else {
          // Other modals
          state.modal.object = arg.object
        }
        
        state.modal.mode = arg.mode || ''
        state.modal.current = arg.name
      },
      CLOSE_MODAL (state) {
        state.modal.current = ''
        state.modal.object = {}
        state.modal.mode = ''

      },
      SAVE_SPIFFS_LEADS_SETUP (state, options) {
        state.baseData.spiffsLeadsSetup = options
        const tmp = state.baseData
        state.baseData = null // to refresh reactivity
        state.baseData = tmp
      },

      // This activates the 'select objects' mode
      SELECT_OBJECTS (state, filter) {
        state.selectedObjects.objectsJson = new ObjectsWithId()
        state.selectedObjects.filter = filter || null
      },
      // This deactivates the 'select objects' mode
      STOP_SELECT_OBJECTS (state) {
        state.selectedObjects.objectsJson = null
        state.selectedObjects.filter = null
      },
      // This updates the list of selected objects
      SELECT_OBJECT (state, obj) {
        if (obj && obj.id && state.selectedObjects.objectsJson) {
          if (state.selectedObjects.objectsJson[obj.id]) { // if object already selected, we remove it
            delete state.selectedObjects.objectsJson[obj.id]
          }
          else { // otherwise we add it
            state.selectedObjects.objectsJson[obj.id] = obj
          }
          state.selectedObjects.objectsJson = new ObjectsWithId(state.selectedObjects.objectsJson.values) // to force refresh bindings
        }
      }
    },








    



    
    /////////////////////////////////////////////////////
    ///////////////////// ACTIONS ///////////////////////
    /////////////////////////////////////////////////////
    actions: {

      openModal     ({state, commit}, arg)  {
        commit('OPEN_MODAL', arg)
        return { res: true }
      },
      closeModal    ({state, commit}) {
        commit('CLOSE_MODAL')
        return { res: true }
      },


      async createPaymentCard ({commit}, card) {
        NProgress.start()
        NProgress.set(0.4)
        const response = await api.createPaymentCard(card)
        NProgress.done()
        return response
      },

      async updatePaymentCard ({commit}, card) {
        NProgress.start()
        NProgress.set(0.4)
        const response = await api.updatePaymentCard(card)
        NProgress.done()
        return response
      },
      
      async loadPaymentCard ({commit}, { paymentCardId, paymentCardProviderId, amount, affiliateAccountId }) {
        NProgress.start()
        NProgress.set(0.4)
        const response = await api.loadPaymentCard(paymentCardId, paymentCardProviderId, amount, affiliateAccountId)
        NProgress.done()
        return response
      },
      
      async unloadPaymentCard ({commit}, { paymentCardId, paymentCardProviderId, amount, affiliateAccountId }) {
        NProgress.start()
        NProgress.set(0.4)
        const response = await api.unloadPaymentCard(paymentCardId, paymentCardProviderId, amount, affiliateAccountId)
        NProgress.done()
        return response
      },

      async payPayout ({commit}, payout) {
        NProgress.start()
        NProgress.set(0.4)
        const response = await api.payPayout(payout)
        NProgress.done()
        return response
      },
      
      async payAffiliatePayoutsFromIncentifyer ({commit}, {affiliateAccountId, incentifyerAccountId}) {
        NProgress.start()
        NProgress.set(0.4)
        const response = await api.payAffiliatePayoutsFromIncentifyer(affiliateAccountId, incentifyerAccountId)
        NProgress.done()
        return response
      },
      
      async updatePayoutStatus ({commit, dispatch}, { incentifyerAccountId, payoutId, status }) {
        NProgress.start()
        NProgress.set(0.4)
        const response = await api.updatePayoutStatus(incentifyerAccountId, payoutId, status)
        dispatch('fetchDataset')
        return response
      },
      
      async impersonateIncentifyerAccount ({commit}, accountId) {
        // console.log('account = ', accountId)
        NProgress.start()
        NProgress.set(0.4)
        const response = await api.impersonateAccount('incentifyer', accountId)
        NProgress.done()
        return response
      },
      
      async impersonateAffiliateAccount ({commit}, accountId) {
        NProgress.start()
        NProgress.set(0.4)
        const response = await api.impersonateAccount('affiliate', accountId)
        NProgress.done()
        return response
      },
      
      
      //////////////////////////// Session: //////////////////////////
      async login ({commit}, creds) {
        NProgress.start()
        NProgress.set(0.4)
        var response = await api.login(creds)
        console.log('Store > login(): response = ', response)
        if (response.errors) {
          console.log('Store > login(): error')
          NProgress.done()
          return response
        }
        else {
          if (response.userSession && response.userSession.user
           && response.userSession.user.status == 'pending') {
            router.push('/changePassword')
          }
          else {
            router.push('/admin')//.catch(e => console.log('catch in login():', e))
          }
          // NProgress.done()
          return response
        }
      },
      
      /** Change the user password */
      async changePassword ({commit}, password) {
        NProgress.start()
        NProgress.set(0.4)
        const response = await api.changePassword(password)
        if (!response.errors) {
          router.push('/admin')
          return
        }
        else  {
          NProgress.done()
          return response
        }
      },

      /** Clears the session in the local storage, close any open modal, and reroutes to login page */
      async logout ({commit}) {
        console.log('Store > logout()')
        commit('CLEAR_SESSION')
        commit('CLOSE_MODAL')
        router.push('/login')
      },
      async isSessionValid ({commit}) {
         return await api.isSessionValid()
      },
      setToken ({commit}, token) {
        api.setDefaultToken(token)
        return true
      },

      //////////////////////////// Base Data: ////////////////////////////

      async fetchBaseData ({state, commit}, scope = router.currentRoute.path.split('/')[2]) {
        //if (!state.baseData.loaded) {
          const res = (await api.fetchBaseData(scope))
          if (res && res.baseData) {
            var baseData = res.baseData
            console.log('fetchBaseData(): ', baseData)
            // TODO
            commit('UPDATE_BASE_DATA', baseData)
          }
          else {
            // We don't show the session invalid message because the apiService already reroutes to login page
            if (!(typeof result.errors[0] == 'string' && result.errors[0].toLowerCase().includes('session'))) {
              Vue.prototype.$notify({errorMessage: result.errors.reduce((accumulator, currentValue) => accumulator + '; ' + currentValue.message)})
            }
            NProgress.done()
          }
        //}
      },


    
    /////////////////////// FETCH DATA ////////////////////////
    

      async fetchDataset ({state, commit}, { period = (state.periodSelected ? state.periodSelected.value || 'this month+' : 'this month+'),
                                          scope = router.currentRoute.path.split('/')[2] }={}) {
        console.log(`fetchDataset(): ${period}, ${scope}`)
        // get the data from the API
        if (!period) {
          console.log('No period provided to store.js: fetchDataset()')
          return undefined
        }
        // console.log(`Before fetch`)
        NProgress.start()
        // NProgress.inc(0.4)
        const result = await api.fetchData(period, scope)
        
        // console.log('fetchDataset get result = ', result)

        if (!result) {
          NProgress.done()
          return result
        }
        if (result.errors) {
          // We don't show the session invalid message because the apiService already reroutes to login page
          if (!(typeof result.errors[0] == 'string' && result.errors[0].toLowerCase().includes('session'))) {
            Vue.prototype.$notify({errorMessage: result.errors.reduce((accumulator, currentValue) => accumulator + '; ' + currentValue.message)})
          }
          NProgress.done()
          return { result: false }
        }
        else {
          commit('UPDATE_DATASET', result.dataset)
          NProgress.done()
          return { result: true }
        }
      }
    }
})